import { Divider, styled } from "@mui/material";
import { theme } from "../theme";

export const StyledDivider = styled(Divider)({
  margin: "35px auto",
  maxWidth: "950px",
  borderColor: theme.color["6D"],
});
